<template>
  <div class="poster-wrap">
    <el-dialog title="修改持仓量" width="600px" :visible="updatePosterDialog" @close="closeDialog">
      <el-form ref="forms" label-width="100px">
        <el-form-item label="币种：" prop="coinType">{{detail.coinType}}</el-form-item>
        <el-form-item label="持仓量：" prop="amount">
          <el-input-number v-model="detail.amount"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Upload from "components/upload";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      detail: {}
    };
  },
  props: ["onePoster"],
  computed: {
    ...mapState("chatroom", ["updatePosterDialog"])
  },
  methods: {
    ...mapActions("chatroom", ["uploadPoster", "list"]),
    ...mapMutations("chatroom", ["setupdatePosterDialog"]),
    closeDialog() {
      this.setupdatePosterDialog(false);
    },
    handleSave() {
      this.uploadPoster({ ...this.detail })
        .then(res => {
          this.$message.success("操作成功！");
          this.$emit("refresh");
        })
        .finally(() => {
          this.setupdatePosterDialog(false);
        });
    }
  },
  watch: {
    onePoster(val, oldVal) {
      if (val !== oldVal) {
        this.detail = { ...val };
      }
    }
  },

  mounted() {}
};
</script>
<style lang="less">
</style>
